import { IPaginatedData } from "@app/common";
import { isFunction } from "./kindOf";

export const extractData = <T>(paginatedData: IPaginatedData<T> | undefined, sort?: ((a: T, b: T) => number)): T[] => {
  const data = (paginatedData?.data ?? []);

  if (isFunction(sort)) {
  }

  return data;
}

export function createFormData<T extends Record<string, any> = any>(data: T, formData = new FormData(), parentKey = '') {
  if (data === null || data === undefined) {
    return formData;
  }

  if (typeof data === 'boolean') {
    formData.append(parentKey, data ? 'true' : 'false');
  } else if (typeof data === 'object' && !(data instanceof File)) {
    if (Array.isArray(data)) {
      if (data.length === 0) {
        // Pour les tableaux vides, ajouter une entrée explicite
        formData.append(parentKey, JSON.stringify([]));
      } else {
        data.forEach((value, index) => {
          const newKey = parentKey ? `${parentKey}[${index}]` : `${index}`;
          createFormData(value, formData, newKey);
        });
      }
    } else {
      Object.keys(data).forEach(key => {
        const newKey = parentKey ? `${parentKey}[${key}]` : key;
        createFormData(data[key], formData, newKey);
      });
    }
  } else {
    formData.append(parentKey, data);
  }

  return formData;
}